/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'housecall-ui/dist/DesignSystem/Navigation/Menus/MenuItem';
import { Field } from 'redux-form';
import TextField from 'housecall-ui/dist/DesignSystem/Inputs/TextFields/TextField';

const CountryField = ({ fullWidth, input, ...custom }) => {
  const [country, setCountry] = useState('');

  return (
    <TextField
      select
      onChange={(event) => setCountry(event.target.value)}
      value={country}
      fullWidth={fullWidth}
      data-testid="mojio-country-select"
      {...custom}
      {...input}
    >
      <MenuItem value="US">United States</MenuItem>
    </TextField>
  );
};

const MojioCountrySelect = (props) => (
  <Field
    component={CountryField}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

CountryField.propTypes = {
  fullWidth: PropTypes.bool.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  input: PropTypes.any,
};

export default MojioCountrySelect;
